// extracted by mini-css-extract-plugin
module.exports = {"logo":"navbar_logo___IyD2","drawerList":"navbar_drawerList__avyFK","spacer":"navbar_spacer__gwE9v","menuIcon":"navbar_menuIcon__Eazm_"};